import { render } from "./AccountManagementPage.vue?vue&type=template&id=79cd8b8f"
import script from "./AccountManagementPage.vue?vue&type=script&lang=js"
export * from "./AccountManagementPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__